export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 order-2 lg:order-1 flex justify-center">
            <div className="relative w-full max-w-[400px] aspect-[4/3] rounded-2xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Cozy%20reading%20atmosphere%20with%20comic%20books%20and%20digital%20tablet%20displaying%20webtoon%2C%20warm%20ambient%20lighting%2C%20comfortable%20modern%20interior%2C%20minimal%20decor%2C%20relaxing%20vibe%2C%20coral%20and%20cream%20color%20palette%2C%20editorial%20photography&width=800&height=600&seq=about-illustration-01&orientation=landscape"
                alt="番茄漫画平台介绍 - 沉浸式阅读体验"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <div className="flex-1 order-1 lg:order-2 text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100/70 text-secondary-700 text-xs font-medium mb-5">
              <i className="ri-information-line"></i>
              <span>关于番茄漫画</span>
            </div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-5">
              让每一话都行云流水
            </h2>
            <div className="space-y-4 text-foreground-500 text-sm md:text-base leading-relaxed max-w-xl mx-auto lg:mx-0">
              <p>
                番茄漫画是一个专注于<strong className="text-foreground-800">下拉式竖屏漫画阅读</strong>的平台。
                我们打破了传统翻页阅读的局限，为读者带来滚动阅读的连续流畅体验——就像刷短视频一样自然，
                让漫画故事在指尖流淌。
              </p>
              <p>
                平台覆盖<strong className="text-foreground-800">韩漫、日漫、国漫</strong>三大品类，
                从热门连载到经典完结，从热血格斗到甜宠恋爱，全部免费畅读。
                支持<strong className="text-foreground-800">离线缓存</strong>功能，
                让你在没有网络的时候也能沉浸式追更。
              </p>
              <p>
                每天更新<strong className="text-foreground-800">1000+</strong>话内容，
                千万读者在这里找到属于自己的漫画世界。番茄漫画，让阅读成为享受。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}